
import React, { useEffect } from 'react';
import { Header } from "@/components/Header";
import { FooterSection } from "@/components/FooterSection";
import PracticeManagementContent from "@/components/expertise/PracticeManagementContent";

const PracticeManagement = () => {
  useEffect(() => {
    document.title = "AI Law Practice Management Solutions | DocketLabs";
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'AI practice management solutions for law firms. Optimize operations, billing & resource allocation. Maximize your efficiency.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'AI practice management solutions for law firms. Optimize operations, billing & resource allocation. Maximize your efficiency.';
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
  }, []);

  return (
    <>
      <Header />
      <div className="pt-24 bg-background min-h-screen">
        <PracticeManagementContent />
      </div>
      <FooterSection />
    </>
  );
};

export default PracticeManagement;
